import { ReactComponent as AddCalendar } from 'assets/rebrand/icons/addCalendar.svg';
import { ReactComponent as AddCalendarFilled } from 'assets/rebrand/icons/addCalendarFilled.svg';
import { ReactComponent as Airport } from 'assets/rebrand/icons/airport.svg';
import { ReactComponent as AirportFilled } from 'assets/rebrand/icons/airportFilled.svg';
import { ReactComponent as ArrowDown } from 'assets/rebrand/icons/arrowDown.svg';
import { ReactComponent as ArrowInCircleRight } from 'assets/rebrand/icons/arrowInCircleRight.svg';
import { ReactComponent as ArrowInCircleRightFilled } from 'assets/rebrand/icons/arrowInCircleRightFilled.svg';
import { ReactComponent as ArrowLeft } from 'assets/rebrand/icons/arrowLeft.svg';
import { ReactComponent as ArrowRight } from 'assets/rebrand/icons/arrowRight.svg';
import { ReactComponent as ArrowThinRight } from 'assets/rebrand/icons/arrowThinRight.svg';
import { ReactComponent as ArrowUp } from 'assets/rebrand/icons/arrowUp.svg';
import { ReactComponent as Basket } from 'assets/rebrand/icons/basket.svg';
import { ReactComponent as Bin } from 'assets/rebrand/icons/bin.svg';
import { ReactComponent as BinFilled } from 'assets/rebrand/icons/binFilled.svg';
import { ReactComponent as Burger } from 'assets/rebrand/icons/burger.svg';
import { ReactComponent as BurgerCross } from 'assets/rebrand/icons/burgerCross.svg';
import { ReactComponent as Business } from 'assets/rebrand/icons/business.svg';
import { ReactComponent as Calendar } from 'assets/rebrand/icons/calendar.svg';
import { ReactComponent as CalendarFilled } from 'assets/rebrand/icons/calendarFilled.svg';
import { ReactComponent as CancelJourney } from 'assets/rebrand/icons/cancelJourney.svg';
import { ReactComponent as CancelJourneyFilled } from 'assets/rebrand/icons/cancelJourneyFilled.svg';
import { ReactComponent as ChangeTime } from 'assets/rebrand/icons/changeTime.svg';
import { ReactComponent as ChevronBrandedDown } from 'assets/rebrand/icons/chevronBrandedDown.svg';
import { ReactComponent as ChevronBrandedLeft } from 'assets/rebrand/icons/chevronBrandedLeft.svg';
import { ReactComponent as ChevronBrandedRight } from 'assets/rebrand/icons/chevronBrandedRight.svg';
import { ReactComponent as ChevronBrandedUp } from 'assets/rebrand/icons/chevronBrandedUp.svg';
import { ReactComponent as ChevronDown } from 'assets/rebrand/icons/chevronDown.svg';
import { ReactComponent as ChevronLeft } from 'assets/rebrand/icons/chevronLeft.svg';
import { ReactComponent as ChevronRight } from 'assets/rebrand/icons/chevronRight.svg';
import { ReactComponent as ChevronSmallDown } from 'assets/rebrand/icons/chevronSmallDown.svg';
import { ReactComponent as ChevronSmallLeft } from 'assets/rebrand/icons/chevronSmallLeft.svg';
import { ReactComponent as ChevronSmallRight } from 'assets/rebrand/icons/chevronSmallRight.svg';
import { ReactComponent as ChevronSmallUp } from 'assets/rebrand/icons/chevronSmallUp.svg';
import { ReactComponent as ChevronUp } from 'assets/rebrand/icons/chevronUp.svg';
import { ReactComponent as Circle } from 'assets/rebrand/icons/circle.svg';
import { ReactComponent as ClaimPointsFilled } from 'assets/rebrand/icons/claimPointsFilled.svg';
import { ReactComponent as Clock } from 'assets/rebrand/icons/clock.svg';
import { ReactComponent as ClockEvening } from 'assets/rebrand/icons/clockEvening.svg';
import { ReactComponent as ClockEveningFilled } from 'assets/rebrand/icons/clockEveningFilled.svg';
import { ReactComponent as ClockFilled } from 'assets/rebrand/icons/clockFilled.svg';
import { ReactComponent as ClockMorning } from 'assets/rebrand/icons/clockMorning.svg';
import { ReactComponent as ClockMorningFilled } from 'assets/rebrand/icons/clockMorningFilled.svg';
import { ReactComponent as ClubCardFilled } from 'assets/rebrand/icons/clubCardFilled.svg';
import { ReactComponent as Cross } from 'assets/rebrand/icons/cross.svg';
import { ReactComponent as DashboardFilled } from 'assets/rebrand/icons/dashboardFilled.svg';
import { ReactComponent as DoorHandle } from 'assets/rebrand/icons/doorHandle.svg';
import { ReactComponent as DoorHandleFilled } from 'assets/rebrand/icons/doorHandleFilled.svg';
import { ReactComponent as DoubleChevronLeft } from 'assets/rebrand/icons/doubleChevronLeft.svg';
import { ReactComponent as Edit } from 'assets/rebrand/icons/edit.svg';
import { ReactComponent as EditFilled } from 'assets/rebrand/icons/editFilled.svg';
import { ReactComponent as EurostarClubCardFilled } from 'assets/rebrand/icons/eurostarClubCardFilled.svg';
import { ReactComponent as Exclamation } from 'assets/rebrand/icons/exclamation.svg';
import { ReactComponent as ExclamationFilled } from 'assets/rebrand/icons/exclamationFilled.svg';
import { ReactComponent as ExternalLink } from 'assets/rebrand/icons/externalLink.svg';
import { ReactComponent as Family } from 'assets/rebrand/icons/family.svg';
import { ReactComponent as FlagBeCircle } from 'assets/rebrand/icons/flagBeCircle.svg';
import { ReactComponent as FlagBeRect } from 'assets/rebrand/icons/flagBeRect.svg';
import { ReactComponent as FlagDeCircle } from 'assets/rebrand/icons/flagDeCircle.svg';
import { ReactComponent as FlagFrCircle } from 'assets/rebrand/icons/flagFrCircle.svg';
import { ReactComponent as FlagFrRect } from 'assets/rebrand/icons/flagFrRect.svg';
import { ReactComponent as FlagNlCircle } from 'assets/rebrand/icons/flagNlCircle.svg';
import { ReactComponent as FlagNlRect } from 'assets/rebrand/icons/flagNlRect.svg';
import { ReactComponent as FlagRwCircle } from 'assets/rebrand/icons/flagRwCircle.svg';
import { ReactComponent as FlagRwRect } from 'assets/rebrand/icons/flagRwRect.svg';
import { ReactComponent as FlagUkCircle } from 'assets/rebrand/icons/flagUkCircle.svg';
import { ReactComponent as FlagUkRect } from 'assets/rebrand/icons/flagUkRect.svg';
import { ReactComponent as FlagUsCircle } from 'assets/rebrand/icons/flagUsCircle.svg';
import { ReactComponent as FlagUsRect } from 'assets/rebrand/icons/flagUsRect.svg';
import { ReactComponent as Fullscreen } from 'assets/rebrand/icons/fullscreen.svg';
import { ReactComponent as FullscreenFilled } from 'assets/rebrand/icons/fullscreenFilled.svg';
import { ReactComponent as Gallery } from 'assets/rebrand/icons/gallery.svg';
import { ReactComponent as GalleryFilled } from 'assets/rebrand/icons/galleryFilled.svg';
import { ReactComponent as Groups } from 'assets/rebrand/icons/groups.svg';
import { ReactComponent as GroupsFilled } from 'assets/rebrand/icons/groupsFilled.svg';
import { ReactComponent as Guest } from 'assets/rebrand/icons/guest.svg';
import { ReactComponent as GuestFilled } from 'assets/rebrand/icons/guestFilled.svg';
import { ReactComponent as Help } from 'assets/rebrand/icons/help.svg';
import { ReactComponent as HelpFilled } from 'assets/rebrand/icons/helpFilled.svg';
import { ReactComponent as HorizontalSwap } from 'assets/rebrand/icons/horizontalSwap.svg';
import { ReactComponent as Hotel } from 'assets/rebrand/icons/hotel.svg';
import { ReactComponent as HotelFilled } from 'assets/rebrand/icons/hotelFilled.svg';
import { ReactComponent as Information } from 'assets/rebrand/icons/information.svg';
import { ReactComponent as InformationFilled } from 'assets/rebrand/icons/informationFilled.svg';
import { ReactComponent as Location } from 'assets/rebrand/icons/location.svg';
import { ReactComponent as LocationFilled } from 'assets/rebrand/icons/locationFilled.svg';
import { ReactComponent as LogoutFilled } from 'assets/rebrand/icons/logoutFilled.svg';
import { ReactComponent as Mail } from 'assets/rebrand/icons/mail.svg';
import { ReactComponent as MailFilled } from 'assets/rebrand/icons/mailFilled.svg';
import { ReactComponent as Meal } from 'assets/rebrand/icons/meal.svg';
import { ReactComponent as MealFilled } from 'assets/rebrand/icons/mealFilled.svg';
import { ReactComponent as Minus } from 'assets/rebrand/icons/minus.svg';
import { ReactComponent as MinusInCircle } from 'assets/rebrand/icons/minusInCircle.svg';
import { ReactComponent as MinusInCircleFilled } from 'assets/rebrand/icons/minusInCircleFilled.svg';
import { ReactComponent as Nights } from 'assets/rebrand/icons/nights.svg';
import { ReactComponent as NightsFilled } from 'assets/rebrand/icons/nightsFilled.svg';
import { ReactComponent as OffersFilled } from 'assets/rebrand/icons/offersFilled.svg';
import { ReactComponent as PassDiscount } from 'assets/rebrand/icons/passDiscount.svg';
import { ReactComponent as PassDiscountFilled } from 'assets/rebrand/icons/passDiscountFilled.svg';
import { ReactComponent as PasswordHide } from 'assets/rebrand/icons/passwordHide.svg';
import { ReactComponent as PasswordShow } from 'assets/rebrand/icons/passwordShow.svg';
import { ReactComponent as PastBooking } from 'assets/rebrand/icons/pastBooking.svg';
import { ReactComponent as Plus } from 'assets/rebrand/icons/plus.svg';
import { ReactComponent as PlusInCircle } from 'assets/rebrand/icons/plusInCircle.svg';
import { ReactComponent as PlusInCircleFilled } from 'assets/rebrand/icons/plusInCircleFilled.svg';
import { ReactComponent as Print } from 'assets/rebrand/icons/print.svg';
import { ReactComponent as PrintFilled } from 'assets/rebrand/icons/printFilled.svg';
import { ReactComponent as Retry } from 'assets/rebrand/icons/retry.svg';
import { ReactComponent as Seat } from 'assets/rebrand/icons/seat.svg';
import { ReactComponent as SeatFilled } from 'assets/rebrand/icons/seatFilled.svg';
import { ReactComponent as SecondContact } from 'assets/rebrand/icons/secondContact.svg';
import { ReactComponent as SettingsFilled } from 'assets/rebrand/icons/settingsFilled.svg';
import { ReactComponent as Star } from 'assets/rebrand/icons/star.svg';
import { ReactComponent as StationGuide } from 'assets/rebrand/icons/stationGuide.svg';
import { ReactComponent as StationGuideFilled } from 'assets/rebrand/icons/stationGuideFilled.svg';
import { ReactComponent as Tick } from 'assets/rebrand/icons/tick.svg';
import { ReactComponent as Tickets } from 'assets/rebrand/icons/tickets.svg';
import { ReactComponent as TicketsFilled } from 'assets/rebrand/icons/ticketsFilled.svg';
import { ReactComponent as TickInCircle } from 'assets/rebrand/icons/tickInCircle.svg';
import { ReactComponent as TickInCircleFilled } from 'assets/rebrand/icons/tickInCircleFilled.svg';
import { ReactComponent as Train } from 'assets/rebrand/icons/train.svg';
import { ReactComponent as Train2Filled } from 'assets/rebrand/icons/train2Filled.svg';
import { ReactComponent as TrainCancelledFilled } from 'assets/rebrand/icons/trainCancelledFilled.svg';
import { ReactComponent as TrainFilled } from 'assets/rebrand/icons/trainFilled.svg';
import { ReactComponent as TrashFilled } from 'assets/rebrand/icons/trashFilled.svg';
import { ReactComponent as TravelDoc } from 'assets/rebrand/icons/travelDoc.svg';
import { ReactComponent as TravelDocFilled } from 'assets/rebrand/icons/travelDocFilled.svg';
import { ReactComponent as Upgrade } from 'assets/rebrand/icons/upgrade.svg';
import { ReactComponent as UpgradeFilled } from 'assets/rebrand/icons/upgradeFilled.svg';
import { ReactComponent as UserFilled } from 'assets/rebrand/icons/userFilled.svg';
import { ReactComponent as UserOutlined } from 'assets/rebrand/icons/userOutlined.svg';
import { ReactComponent as WarningTriangle } from 'assets/rebrand/icons/warningTriangle.svg';
import { ReactComponent as WarningTriangleFilled } from 'assets/rebrand/icons/warningTriangleFilled.svg';
import { ReactComponent as Wheelchair } from 'assets/rebrand/icons/wheelchair.svg';
import { ReactComponent as WheelchairFilled } from 'assets/rebrand/icons/wheelchairFilled.svg';

const icons = {
  AddCalendar,
  AddCalendarFilled,
  Airport,
  AirportFilled,
  ArrowDown,
  ArrowInCircleRight,
  ArrowInCircleRightFilled,
  ArrowLeft,
  ArrowRight,
  ArrowThinRight,
  ArrowUp,
  Basket,
  Bin,
  BinFilled,
  Burger,
  BurgerCross,
  Business,
  Calendar,
  CalendarFilled,
  CancelJourney,
  CancelJourneyFilled,
  ChangeTime,
  ChevronBrandedDown,
  ChevronBrandedLeft,
  ChevronBrandedRight,
  ChevronBrandedUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSmallDown,
  ChevronSmallLeft,
  ChevronSmallRight,
  ChevronSmallUp,
  ChevronUp,
  Circle,
  ClaimPointsFilled,
  Clock,
  ClockEvening,
  ClockEveningFilled,
  ClockFilled,
  ClockMorning,
  ClockMorningFilled,
  ClubCardFilled,
  Cross,
  DashboardFilled,
  DoorHandle,
  DoorHandleFilled,
  DoubleChevronLeft,
  Edit,
  EditFilled,
  EurostarClubCardFilled,
  Exclamation,
  ExclamationFilled,
  ExternalLink,
  Family,
  FlagBeCircle,
  FlagBeRect,
  FlagDeCircle,
  FlagFrCircle,
  FlagFrRect,
  FlagNlCircle,
  FlagNlRect,
  FlagRwCircle,
  FlagRwRect,
  FlagUkCircle,
  FlagUkRect,
  FlagUsCircle,
  FlagUsRect,
  Fullscreen,
  FullscreenFilled,
  Gallery,
  GalleryFilled,
  Groups,
  GroupsFilled,
  Guest,
  GuestFilled,
  Help,
  HelpFilled,
  HorizontalSwap,
  Hotel,
  HotelFilled,
  Information,
  InformationFilled,
  Location,
  LocationFilled,
  LogoutFilled,
  Mail,
  MailFilled,
  Meal,
  MealFilled,
  Minus,
  MinusInCircle,
  MinusInCircleFilled,
  Nights,
  NightsFilled,
  OffersFilled,
  PassDiscount,
  PassDiscountFilled,
  PasswordHide,
  PasswordShow,
  PastBooking,
  Plus,
  PlusInCircle,
  PlusInCircleFilled,
  Print,
  PrintFilled,
  Retry,
  Seat,
  SeatFilled,
  SecondContact,
  SettingsFilled,
  Star,
  StationGuide,
  StationGuideFilled,
  Tick,
  Tickets,
  TicketsFilled,
  TickInCircle,
  TickInCircleFilled,
  Train,
  Train2Filled,
  TrainCancelledFilled,
  TrainFilled,
  TrashFilled,
  TravelDoc,
  TravelDocFilled,
  Upgrade,
  UpgradeFilled,
  UserFilled,
  UserOutlined,
  WarningTriangle,
  WarningTriangleFilled,
  Wheelchair,
  WheelchairFilled
};

export default icons;
